"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _config = _interopRequireWildcard(require("../config"));

var _shared = require("@exc/shared");

var _Messenger = require("../Messenger");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const topbar = {
  onHeroClick: callback => {
    _Messenger.messenger.send(_shared.Events.CUSTOM_HERO_CLICK);

    _Messenger.messenger.setCallback(_shared.Events.HERO_CLICK, callback);
  },
  setCoachMark: coachMark => {
    if (!coachMark) {
      _config.default.clear('coachMark');

      return;
    }

    (0, _config.update)('coachMark', coachMark, _shared.Events.COACH_MARK_POSITIONED);
  },
  setCustomSearch: customSearch => {
    if (!customSearch) {
      _config.default.clear('customSearch', _shared.Events.CUSTOM_SEARCH);

      return;
    }

    (0, _config.update)('customSearch', customSearch, _shared.Events.CUSTOM_SEARCH);
  },
  setFeedbackButton: feedback => {
    if (!feedback) {
      _config.default.clear('feedback', _shared.Events.CUSTOM_FEEDBACK);

      return;
    }

    (0, _config.update)('feedback', feedback, _shared.Events.CUSTOM_FEEDBACK, feedback.type !== 'custom');
  }
};
(0, _config.setupConfig)(topbar, ['customEnvLabel', 'solution', 'workspaces']);
var _default = topbar;
exports.default = _default;